"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const format_1 = __importDefault(require("date-fns/format"));
const react_suspender_1 = __importDefault(require("react-suspender"));
const client_2 = require("../../client");
const MapmakerApi_1 = require("../../client/MapmakerApi");
const ErrorPage_1 = __importDefault(require("../../lib/errors/ErrorPage"));
const SanityContent_1 = __importDefault(require("../help/sanity/SanityContent"));
const utils_1 = require("../help/sanity/serializers/utils");
const BlogPostCardList_1 = __importDefault(require("./BlogPostCardList"));
require("./MapmakerBlogPost.css");
(0, client_1.gql) `
  fragment BlogPost on Post {
    _id
    title
    slug {
      current
    }
    author {
      name
      slug {
        current
      }
    }
    mainImage {
      asset {
        _id
        url
        path
        assetId
        extension
      }
    }
    publishedAt
    bodyRaw
  }

  query blogPost($slug: String!) {
    post: allPost(where: { slug: { current: { eq: $slug } } }) {
      ...BlogPost
    }
    recentPosts: allPost(sort: [{ publishedAt: DESC }]) {
      ...BlogPostCard
    }
  }
`;
function MapmakerBlogPost({ slug }) {
    const { gotoBlogPosts } = (0, client_2.useMapmakerAppConfig)();
    const builder = (0, utils_1.useSanityImageUrlBuilder)();
    const { loading, data, error } = (0, MapmakerApi_1.useBlogPostQuery)({
        variables: {
            slug,
        },
    });
    const post = data === null || data === void 0 ? void 0 : data.post[0];
    const recentPosts = data === null || data === void 0 ? void 0 : data.recentPosts;
    if (loading) {
        return (0, jsx_runtime_1.jsx)(react_suspender_1.default, {});
    }
    else if (error || !post) {
        return (0, jsx_runtime_1.jsx)(ErrorPage_1.default, { message: "Could not find blog post." });
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "mapmaker-blog-post" }, { children: [(0, jsx_runtime_1.jsx)("img", { className: "hero", src: builder
                    .image(post.mainImage.asset)
                    .crop("focalpoint")
                    .width(1200)
                    .height(400)
                    .fit("crop")
                    .url() }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "info" }, { children: [(0, jsx_runtime_1.jsx)("h1", { children: post.title }), (0, jsx_runtime_1.jsxs)("h5", { children: [(0, format_1.default)(new Date(post.publishedAt), "PPPP"), " by ", post.author.name] })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body" }, { children: (0, jsx_runtime_1.jsx)(SanityContent_1.default, { content: post.bodyRaw }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "recent-posts" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "top-info" }, { children: [(0, jsx_runtime_1.jsx)("h3", { children: "Recent Articles" }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "link", onClick: gotoBlogPosts }, { children: "View All" }))] })), (0, jsx_runtime_1.jsx)(BlogPostCardList_1.default, { posts: recentPosts })] }))] })));
}
exports.default = MapmakerBlogPost;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJCbG9nUG9zdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2Jsb2cvTWFwbWFrZXJCbG9nUG9zdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsMkNBQXFDO0FBQ3JDLDZEQUFxQztBQUVyQyxzRUFBd0M7QUFDeEMseUNBQW9EO0FBQ3BELDBEQUE0RDtBQUM1RCwyRUFBbUQ7QUFDbkQsaUZBQXlEO0FBQ3pELDREQUE0RTtBQUM1RSwwRUFBa0Q7QUFDbEQsa0NBQWdDO0FBRWhDLElBQUEsWUFBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBa0NGLENBQUM7QUFNRixTQUF3QixnQkFBZ0IsQ0FBQyxFQUFFLElBQUksRUFBeUI7SUFDdEUsTUFBTSxFQUFFLGFBQWEsRUFBRSxHQUFHLElBQUEsNkJBQW9CLEdBQUUsQ0FBQztJQUNqRCxNQUFNLE9BQU8sR0FBRyxJQUFBLGdDQUF3QixHQUFFLENBQUM7SUFDM0MsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsS0FBSyxFQUFFLEdBQUcsSUFBQSw4QkFBZ0IsRUFBQztRQUNoRCxTQUFTLEVBQUU7WUFDVCxJQUFJO1NBQ0w7S0FDRixDQUFDLENBQUM7SUFFSCxNQUFNLElBQUksR0FBRyxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQzNCLE1BQU0sV0FBVyxHQUFHLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxXQUFXLENBQUM7SUFFdEMsSUFBSSxPQUFPLEVBQUU7UUFDWCxPQUFPLHVCQUFDLHlCQUFTLEtBQUcsQ0FBQztLQUN0QjtTQUFNLElBQUksS0FBSyxJQUFJLENBQUMsSUFBSSxFQUFFO1FBQ3pCLE9BQU8sdUJBQUMsbUJBQVMsSUFBQyxPQUFPLEVBQUMsMkJBQTJCLEdBQUcsQ0FBQztLQUMxRDtJQUVELE9BQU8sQ0FDTCwrQ0FBSyxFQUFFLEVBQUMsb0JBQW9CLGlCQUMxQixnQ0FDRSxTQUFTLEVBQUMsTUFBTSxFQUNoQixHQUFHLEVBQUUsT0FBTztxQkFDVCxLQUFLLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUM7cUJBQzNCLElBQUksQ0FBQyxZQUFZLENBQUM7cUJBQ2xCLEtBQUssQ0FBQyxJQUFJLENBQUM7cUJBQ1gsTUFBTSxDQUFDLEdBQUcsQ0FBQztxQkFDWCxHQUFHLENBQUMsTUFBTSxDQUFDO3FCQUNYLEdBQUcsRUFBRSxHQUNSLEVBQ0YsK0NBQUssU0FBUyxFQUFDLE1BQU0saUJBQ25CLHlDQUFLLElBQUksQ0FBQyxLQUFLLEdBQU0sRUFDckIsMkNBQ0csSUFBQSxnQkFBTSxFQUFDLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsRUFBRSxNQUFNLENBQUMsVUFBTSxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksSUFDOUQsS0FDRCxFQUNOLDhDQUFLLFNBQVMsRUFBQyxNQUFNLGdCQUNuQix1QkFBQyx1QkFBYSxJQUFDLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTyxHQUFJLElBQ3BDLEVBQ04sK0NBQUssU0FBUyxFQUFDLGNBQWMsaUJBQzNCLCtDQUFLLFNBQVMsRUFBQyxVQUFVLGlCQUN2Qiw2REFBd0IsRUFDeEIsK0NBQU0sU0FBUyxFQUFDLE1BQU0sRUFBQyxPQUFPLEVBQUUsYUFBYSw4QkFFdEMsS0FDSCxFQUNOLHVCQUFDLDBCQUFnQixJQUFDLEtBQUssRUFBRSxXQUFXLEdBQUksS0FDcEMsS0FDRixDQUNQLENBQUM7QUFDSixDQUFDO0FBbERELG1DQWtEQyJ9